import {  OnInit, Component } from '@angular/core';
import { RouterEvent } from '@angular/router';
import { UdeAdminService } from '../../../services/ude-admin/ude-admin.service';
import { AuthService } from '../../../services/auth/auth.service';
import { FormBuilder,FormGroup,FormControl,Validators  } from '@angular/forms';
import { UtilService } from '../../../services/util/util.service';
import { MatDialog } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-bulk-update-links',
    templateUrl: './bulk-update-links.component.html',
    styleUrl: './bulk-update-links.component.scss',
    standalone: false
})
export class BulkUpdateLinksComponent {
  adminForm!: FormGroup;
    categories: Array<{ category_en: string, category_fr: string, _id: string }> = [];
    user: { brand?: string, country?: string } = {};
    allLinks: Array<{ title_en: string, title_fr: string, _id: string,url : string}> = [];
    allCategories:any;
    getAllLinks:any;
    isLoading: number = 0;
    selectedCategory: any = '';
    brand: Array<{ type: string, option: string, selected: boolean }> =
        new Array<{ type: string, option: string, selected: boolean }>(
          { type: "VW", option: "VW", selected: true },{ type: "AU", option: "AU", selected: false });
    country: Array<{ type: string, option: string, selected: boolean }> =
        new Array<{ type: string, option: string, selected: boolean }>(
          { type: "US", option: "US", selected: true },{ type: "CA", option: "CA", selected: false });
  
    sourceLinks: any;
    destinationLinks: any;
    source_category_id: any;
    destination_category_id: any;
    selectedSourceLinks: any[] = [];
    selectedDestinationLinks: any[] = [];

    constructor(private formBuilder: FormBuilder, private authService: AuthService,
      public utilService: UtilService, private adminService: UdeAdminService
        , private dialog: MatDialog) {
          this.authService.getUser().then((user) => {
              this.user = user;
          });
          
       }

      ngOnInit(): void {
        this.sourceLinks = [];
        this.destinationLinks = [];
        this.selectedSourceLinks = [];
        this.selectedDestinationLinks = [];


        this.adminForm = this.formBuilder.group({
          source_category_id: new FormControl(''),
          sourceLinks: new FormControl(''),
          destination_category_id: new FormControl(''),
          destinationLinks: new FormControl(''),
          brand: [this.brand[0].option, Validators.required],
          country: [this.country[0].option, Validators.required]
        });
        this.utilService.showSpinner();
         this.adminService.getAllLinks().subscribe((res) => {
          this.allLinks = res;
          this.utilService.hideSpinner();
         });
        this.adminForm.controls['source_category_id'].enable();
        this.adminForm.controls['destination_category_id'].enable();
         this.fetchAllCategories();
      }

      
  fetchAllCategories(){
    this.sourceLinks = [];
    this.destinationLinks = [];
    this.selectedSourceLinks = [];
    this.selectedDestinationLinks = [];

    this.adminService.getAllCategories(this.adminForm.controls['brand'].value,this.adminForm.controls['country'].value).subscribe({
      next: (data) => {
        this.utilService.hideSpinner();
        //order the categories array by category_en
        data.sort((a: { category_en: string; }, b: { category_en: string; }) => a.category_en.localeCompare(b.category_en));
        this.allCategories = data;

        //fetch the category_en,category_fr,_id from the response and set it to the categories array
        this.categories = data.map((item: any) => ({
          category_en: item.category_en,
          category_fr: item.category_fr,
          _id: item._id
        }));

        
        //this.categories = data.map((item: any) => (item.category_en));
        /* this.selectedCategory = (this.selectedCategory) ? this.selectedCategory : this.categories[0]._id; //set the first category as default or sets the last selected category after deleting the link
        this.adminForm.get('source_category_id')?.setValue(this.selectedCategory); */
      },
      complete: () => {
        this.utilService.hideSpinner();
      }
    }
  );
  }
    
  get f() { return this.adminForm.controls; }

  /*
  * This function is called when the source category is changed
  * It filters the source links based on the selected category
  */
  onSourceCategoryChange(event: any) {
    //push the selected category links to the sourceLinks array from allCategories.links  
    this.sourceLinks = [];
    this.selectedSourceLinks = [];

    //check if the event value is empty or not
    if(event.value === ''){
      return;
    }
    //check if the event value is same as the destination category id or not
    //if it is same then show the warning message and set the source category id to empty
    if(event.value === this.adminForm.controls['destination_category_id'].value){
       this.utilService.openSnackBar('Please select different categories for source and destination.','warning');
       this.adminForm.controls['source_category_id'].setValue('');
       this.source_category_id = '';
       return;
    }
    //push the selected category links to the sourceLinks array from allCategories.links
    this.sourceLinks = this.allCategories.find((item: any) => item._id === event.value).links;
    this.source_category_id = event.value;
  }

  /*
  * This function is called when the destination category is changed
  * It filters the destination links based on the selected category
  */
  onDestinationCategoryChange(event: any) {
    this.destinationLinks = [];
    this.selectedDestinationLinks = [];
    //check if the event value is empty or not
    //if it is empty then return
    if(event.value === ''){
      return;
    }
    //check if the event value is same as the source category id or not
    //if it is same then show the warning message and set the source category id to empty
    if(event.value === this.adminForm.controls['source_category_id'].value){
      this.utilService.openSnackBar('Please select different categories for source and destination.','warning');
      this.adminForm.controls['destination_category_id'].setValue('');
      this.destination_category_id = '';
      return;
    }
    //push the selected category links to the destinationLinks array from allCategories.links
    this.destinationLinks = this.allCategories.find((item: any) => item._id === event.value).links;
    this.destination_category_id = event.value;
  }

  /*
  * This function is called when the source links are selected
  * It filters the selected links from the source links
  */
  onSourceLinksChange(event: any) {
    const selectedOptions = event.source.selectedOptions.selected;
    this.selectedSourceLinks = [];
    // Iterate through selectedOptions to check which items are selected and push them to the selectedSourceLinks array
    selectedOptions.forEach((item:any) => {
      this.selectedSourceLinks.push(item.value);
    });
  }

  /*
  * This function is called when the destination links are selected 
  * It filters the selected links from the destination links
  */
  onDestinationLinksChange(event: any) {
    const selectedOptions = event.source.selectedOptions.selected;
    this.selectedDestinationLinks = [];
    // Iterate through selectedOptions to check which items are selected and push them to the selectedSourceLinks array
    selectedOptions.forEach((item:any) => {
      this.selectedDestinationLinks.push(item.value);
    });

  }

  /*
  * This function is called when the user clicks on the move button
  * It moves the selected links from the source category to the destination category
  */
 

  moveToTarget(){

    // Concatenate the selectedSourceLinks to destinationLinks array if it is not empty
    if(this.adminForm.controls['destination_category_id'].value !== ''){
       
      this.selectedSourceLinks.forEach((link: any) => {
       // link.active = true;// Set active to true for all selectedSourceLinks
        link.new ='Moved'//Set New variable to show the new links
      });

      this.destinationLinks = this.destinationLinks.concat(this.selectedSourceLinks);

      // Remove the selectedSourceLinks from sourceLinks array
      this.sourceLinks = this.sourceLinks.filter((item: any) => !this.selectedSourceLinks.includes(item));


      // Clear the selectedSourceLinks array
      this.selectedSourceLinks = [];
      //disable the source category & destination category once the links are moved
      this.adminForm.controls['source_category_id'].disable();
      this.adminForm.controls['destination_category_id'].disable();
    }

  }

  /*
  * This function is called when the user clicks on the move button
  * It moves the selected links from the destination category to the source category
  */
  moveToSource(){

    if(this.adminForm.controls['source_category_id'].value !== ''){      
      
      this.selectedDestinationLinks.forEach((link: any) => {
        //link.active = true;// Set active to true for all selectedSourceLinks
        link.new ='Moved';//Set New variable to show the new links
      });
      
      // Concatenate the selectedSourceLinks to destinationLinks array if it is not empty
      this.sourceLinks = this.sourceLinks.concat(this.selectedDestinationLinks);

      // Remove the selectedDestinationLinks from destinationLinks array
      this.destinationLinks = this.destinationLinks.filter((item: any) => !this.selectedDestinationLinks.includes(item));
      // Clear the selectedDestinationLinks array
      this.selectedDestinationLinks = [];
      //disable the source category & destination category once the links are moved
      this.adminForm.controls['source_category_id'].disable();
      this.adminForm.controls['destination_category_id'].disable();
    }
     

  }

  save(){
    var postData = {
      source_category_id: this.source_category_id,
      destination_category_id: this.destination_category_id,
      brand: this.adminForm.controls['brand'].value,
      country: this.adminForm.controls['country'].value,
      sourceLinks: this.sourceLinks.map((item: any) => ({ _id: item._id, active: item.active })),
      destinationLinks: this.destinationLinks.map((item: any) => ({ _id: item._id, active: item.active }))
    }
    this.utilService.showSpinner();
    this.adminService.bulkUpdateCategoryLinks(postData).subscribe({
      next: (res) => {
        this.utilService.hideSpinner();
        this.utilService.openSnackBar('Links moved successfully','success');
        this.adminForm.reset();
        this.ngOnInit();
      },
      error: (err) => {
        this.utilService.hideSpinner();
      },
      complete: () => {
        this.utilService.hideSpinner();
      }
    });
    
  }
}
